import { APIS, SERVICES } from 'src/config/constants'
import { QueryKey } from 'src/hooks/constants/queryKeys'
import type { StudentInfoChange } from 'src/interfaces/client/infoChanges'
import { queryClient } from 'src/boot/vue-query'
import { axiosInstance } from 'src/utils/request'

export const studentInfoChangesStaleTime = 30_000

export const studentInfoChangesQueryKey = (
  orgId: string,
  centerId: string,
  familyId: string,
) => [QueryKey.StudentInfoChanges, orgId, centerId, familyId]

export const fetchStudentInfoChanges = async (
  familyId: string,
): Promise<StudentInfoChange[]> => {
  const res = await axiosInstance.get(
    `${SERVICES.per}/${APIS.families}/${familyId}/${APIS.infoChanges}`,
    {
      params: { type: 'student' },
    },
  )

  return res.data
}

export const fetchCachedStudentInfoChanges = async ({
  orgId,
  centerId,
  familyId,
}: {
  orgId?: string
  centerId?: string
  familyId?: string
}): Promise<StudentInfoChange[]> => {
  if (!orgId || !centerId || !familyId) return []

  return queryClient.fetchQuery({
    queryKey: studentInfoChangesQueryKey(orgId, centerId, familyId),
    queryFn: () => fetchStudentInfoChanges(familyId),
    staleTime: studentInfoChangesStaleTime,
  })
}
